import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, EventEmitter, ViewContainerRef } from '@angular/core';
import { ESRI } from '../../../esri-loader-util';
import { ExportService } from '../../../services/export.service';
import { LayerService } from '../../../services/layer.service';
import { PrintService } from '../../../services/print.service';
import { BaseComponent } from '../../base.component';
var ExportMapComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ExportMapComponent, _super);
    function ExportMapComponent(_vcr, layerService, printService, exportService, cdr) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.layerService = layerService;
        _this.printService = printService;
        _this.exportService = exportService;
        _this.cdr = cdr;
        _this.onclose = new EventEmitter();
        _this.mapLayers = [];
        _this.success = false;
        _this.limitToMapExtent = false;
        _this.includeMapImage = true;
        _this.isLoading = false;
        _this.statewideDefault = {
            xmin: -8963167.0999474,
            ymin: 4815933.74691319,
            xmax: -8306549.08350328,
            ymax: 5238680.50536529
        };
        _this._mode = 'excel';
        return _this;
    }
    Object.defineProperty(ExportMapComponent.prototype, "active", {
        get: function () {
            return this._active;
        },
        set: function (value) {
            if (value) {
                this.onActivate();
            }
            this._active = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExportMapComponent.prototype, "mode", {
        get: function () {
            return this._mode.toLowerCase();
        },
        set: function (value) {
            this._mode = value.toLowerCase();
            //TODO: add in code to re-initialize data for the dialouge
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExportMapComponent.prototype, "allChecked", {
        get: function () {
            return this.mapLayers.every(function (layer) { return layer.isChecked && layer.childTables.every(function (child) { return child.isChecked; }); });
        },
        set: function (value) {
            var e_1, _a, e_2, _b;
            try {
                for (var _c = tslib_1.__values(this.mapLayers), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var layer = _d.value;
                    layer.isChecked = value;
                    try {
                        for (var _e = tslib_1.__values(layer.childTables), _f = _e.next(); !_f.done; _f = _e.next()) {
                            var child = _f.value;
                            child.isChecked = value;
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_1) throw e_1.error; }
            }
            this.cdr.detectChanges();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExportMapComponent.prototype, "someChecked", {
        get: function () {
            return !this.allChecked && this.mapLayers.some(function (layer) { return layer.isChecked || layer.childTables.some(function (child) { return child.isChecked; }); });
        },
        enumerable: true,
        configurable: true
    });
    ExportMapComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this;
                        if (!this.mapViewRef) return [3 /*break*/, 1];
                        _b = this.mapViewRef;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.setupMapViewRef(this.mapViewRef)];
                    case 2:
                        _b = _c.sent();
                        _c.label = 3;
                    case 3:
                        _a.mapViewRef = _b;
                        this.isReady();
                        return [2 /*return*/];
                }
            });
        });
    };
    ExportMapComponent.prototype.onActivate = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_3, _a, childTablePromises, _loop_1, this_1, _b, _c, layer;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        this.isLoading = true;
                        this.fileName = this.mapViewRef.mapcoreViewProps.name;
                        this.mapLayers = this.layerService.mapRef.allLayers
                            .filter(function (layer) { return layer.type === 'map-image' && layer.mapcoreProps && !layer.mapcoreProps.hideInLegend; })
                            .map(function (layer) { return ({
                            esriLayer: layer,
                            mapcoreProps: layer.mapcoreProps,
                            childTables: [],
                            isChecked: false
                        }); }).toArray().reverse();
                        childTablePromises = [];
                        _loop_1 = function (layer) {
                            childTablePromises.push(this_1.layerService.getLayerChildTables(this_1.getLayerId(layer.mapcoreProps))
                                .then(function (childTables) {
                                if (childTables && childTables.length) {
                                    layer.childTables = childTables.map(function (t) { return (tslib_1.__assign({}, t, { isChecked: false })); });
                                }
                            }));
                        };
                        this_1 = this;
                        try {
                            for (_b = tslib_1.__values(this.mapLayers), _c = _b.next(); !_c.done; _c = _b.next()) {
                                layer = _c.value;
                                _loop_1(layer);
                            }
                        }
                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_3) throw e_3.error; }
                        }
                        return [4 /*yield*/, Promise.all(childTablePromises)];
                    case 1:
                        _d.sent();
                        this.isLoading = false;
                        this.cdr.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    ExportMapComponent.prototype.exportShapefile = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, Promise.all(this.mapLayers.filter(function (x) { return x.isChecked; }).map(function (layer) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        var props, rootQuery, geometries, exportShapeFileParams;
                        return tslib_1.__generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    props = layer.mapcoreProps;
                                    rootQuery = { operator: 'AND', subqueries: [] };
                                    if (props.parentQuery) {
                                        rootQuery.subqueries.push(props.parentQuery);
                                    }
                                    if (props.query) {
                                        rootQuery.subqueries.push(props.query);
                                    }
                                    geometries = null;
                                    if (!(layer && layer.esriLayer.type && layer.esriLayer.type.toLowerCase() === 'graphics')) return [3 /*break*/, 2];
                                    return [4 /*yield*/, this.layerService.getLayerGeometrySingleType(layer.esriLayer)];
                                case 1:
                                    geometries = _a.sent();
                                    _a.label = 2;
                                case 2:
                                    exportShapeFileParams = {
                                        name: props.name,
                                        columns: props.columns,
                                        tables: props.tables,
                                        query: rootQuery,
                                        geometries: geometries ? geometries.map(function (x) { return x.toJSON(); }) : null
                                    };
                                    return [2 /*return*/, this.exportService.exportToShapeFileAndOpenUrl(exportShapeFileParams)];
                            }
                        });
                    }); }))];
            });
        });
    };
    ExportMapComponent.prototype.exportExcel = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_4, _a, _b, _c, layer, layers, fieldNameOrder, childTableIds, exportParams, printUrl;
            var _this = this;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        try {
                            for (_b = tslib_1.__values(this.mapLayers), _c = _b.next(); !_c.done; _c = _b.next()) {
                                layer = _c.value;
                                layer.mapcoreProps.showInPrintLegend = layer.isChecked;
                            }
                        }
                        catch (e_4_1) { e_4 = { error: e_4_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_4) throw e_4.error; }
                        }
                        layers = this.mapLayers.filter(function (x) { return x.isChecked; }).map(function (y) {
                            var rootQuery = { operator: 'AND', subqueries: [] };
                            // have to combine parentQuery and query if exists
                            if (y.mapcoreProps.parentQuery) {
                                // use current subqueries or use a new one if doesnt exist
                                if (!y.mapcoreProps.query.subqueries) {
                                    if (y.mapcoreProps.query) {
                                        rootQuery.subqueries.push(y.mapcoreProps.query);
                                    }
                                }
                                else {
                                    // overwrite rootQuery if query already has a subqueries
                                    rootQuery = y.mapcoreProps.query;
                                }
                                if (!y.mapcoreProps.parentQuery.subqueries) {
                                    if (y.mapcoreProps.parentQuery) {
                                        rootQuery.subqueries.push(y.mapcoreProps.parentQuery);
                                    }
                                }
                                else {
                                    // add on parent subqueries
                                    y.mapcoreProps.parentQuery.subqueries.forEach(function (subQ) {
                                        rootQuery.subqueries.push(subQ);
                                    });
                                }
                            }
                            else {
                                rootQuery = y.mapcoreProps.query;
                            }
                            return {
                                id: _this.getLayerId(y.mapcoreProps),
                                query: rootQuery,
                                name: y.mapcoreProps.name,
                                columns: y.mapcoreProps.columns
                            };
                        });
                        fieldNameOrder = [];
                        layers.forEach(function (layer) {
                            var layerColumns = layer.columns;
                            if (layerColumns) {
                                layerColumns = layerColumns.sort(function (a, b) {
                                    if (a.databaseColumnOrder > b.databaseColumnOrder) {
                                        return 1;
                                    }
                                    else if (a.databaseColumnOrder < b.databaseColumnOrder) {
                                        return -1;
                                    }
                                    return 0;
                                });
                                fieldNameOrder.push(layerColumns.map(function (x) { return x.name.toUpperCase(); }));
                            }
                        });
                        childTableIds = this.mapLayers.map(function (l) { return l.childTables; }).flat().filter(function (ct) { return ct.isChecked; }).map(function (ct) { return ct.tableId; });
                        exportParams = { layers: layers, childTableIds: childTableIds, includeLayerChildren: !!childTableIds.length, fieldNameOrder: fieldNameOrder };
                        if (!this.includeMapImage) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.printMap()];
                    case 1:
                        printUrl = _d.sent();
                        exportParams.imageUrl = printUrl;
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.exportService.exportToExcelAndOpenUrl(exportParams)];
                    case 3:
                        _d.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ExportMapComponent.prototype.exportMap = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoading = true;
                        if (!(this.mode === 'shapefile')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.exportShapefile()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        this.exportExcel();
                        _a.label = 3;
                    case 3:
                        this.isLoading = false;
                        this.cdr.detectChanges();
                        this.close();
                        return [2 /*return*/];
                }
            });
        });
    };
    ExportMapComponent.prototype.printMap = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var template, extent, Extent, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.mapSelect) {
                            this.mapSelect = '';
                        }
                        template = {
                            selectedLayout: {
                                name: 'ANSI A Landscape (11x8.5)',
                                heightInches: 6.0953,
                                widthInches: 9.7527,
                                id: 1
                            },
                            label: '',
                            format: 'png',
                            layoutOptions: {
                                titleText: this.fileName,
                                authorText: '',
                                copyrightText: 'PennDOT',
                                scalebarUnit: 'Miles',
                                customTextElements: [{ selectText: this.mapSelect }],
                                legendLayers: null
                            },
                            exportOptions: {
                                dpi: 300
                            }
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        extent = this.mapViewRef.extent.clone();
                        if (!!this.limitToMapExtent) return [3 /*break*/, 3];
                        return [4 /*yield*/, ESRI.Extent];
                    case 2:
                        Extent = _a.sent();
                        extent = new Extent({
                            xmin: this.statewideDefault.xmin,
                            xmax: this.statewideDefault.xmax,
                            ymin: this.statewideDefault.ymin,
                            ymax: this.statewideDefault.ymax,
                            spatialReference: this.mapViewRef.spatialReference.toJSON()
                        });
                        _a.label = 3;
                    case 3: return [4 /*yield*/, this.printService.printMap(this.mapViewRef, template, extent, true, null, false, //TODO: Scale drawing layers is an app config option in 1.x. Set to false by default, should we enable a choice?
                        true).then(function (url) {
                            return url;
                        })];
                    case 4: return [2 /*return*/, _a.sent()];
                    case 5:
                        error_1 = _a.sent();
                        this.isLoading = false;
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    ExportMapComponent.prototype.resetSuccess = function () {
        this.success = false;
    };
    ExportMapComponent.prototype.close = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                // reset file name. Layer selection gets reset on activate
                this.fileName = '';
                this.limitToMapExtent = false;
                this.mapLayers = [];
                this.resetSuccess();
                this.onclose.emit(true);
                return [2 /*return*/];
            });
        });
    };
    ExportMapComponent.prototype.getLayerId = function (mapcoreProps) {
        return mapcoreProps.parentId || mapcoreProps.id || mapcoreProps.idFromSavedLayer;
    };
    ExportMapComponent.prototype.toggleCheckAll = function () {
        this.allChecked = !this.allChecked;
    };
    ExportMapComponent.prototype.checkedChange = function (layer) {
        layer.isChecked = !layer.isChecked;
        this.cdr.detectChanges();
    };
    ExportMapComponent.prototype.childCheckedChange = function (child) {
        child.isChecked = !child.isChecked;
        this.cdr.detectChanges();
    };
    return ExportMapComponent;
}(BaseComponent));
export { ExportMapComponent };
